import styleInject from '../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".SubmitButtons_root__sXP-n{display:flex;justify-content:flex-end;margin-top:15px}.SubmitButtons_item__f0l6w+.SubmitButtons_item__f0l6w{margin-left:10px}";
var S = {"root":"SubmitButtons_root__sXP-n","item":"SubmitButtons_item__f0l6w"};
styleInject(css_248z);

export { S as default };
